import ShortcutButtonsPlugin from 'shortcut-buttons-flatpickr';
import { nextIconString, prevIconString } from './flatPickrIconStrings';

const defaultConfig = {
  // format the date that gets written into the input (that will be sent in POST)
  dateFormat: 'Y-m-d H:i',
  // allow time input
  enableTime: true,
  minDate: 'today',
  defaultHour: 9,
  defaultMinute: 0,
  time_24hr: false,
  disableMobile: true,
  plugins: [
    new ShortcutButtonsPlugin({
      button: {
        label: 'Clear',
      },
      onClick: (index, fp) => {
        fp.clear();
        fp.close();
      },
    }),
  ],
  nextArrow: nextIconString,
  prevArrow: prevIconString,
};

export default defaultConfig;
